module.exports = __webpack_public_path__ + "img/logo_cm_valongo.48ee2698.svg";